// extracted by mini-css-extract-plugin
export default {"placeholderContent":"projects_list__placeholderContent__jGwtz","placeholderLabel":"projects_list__placeholderLabel__a6RyG"};